<template>
    <div class="container-fluid">
        <div class="row m-b-30">
            <div class="col-6">
                <h3 class="m-b-0">Add Partner</h3>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Search Partner & Add</h4>
                        <h6 class="card-subtitle">Add an existing partner to this marketplace</h6>
                    </div>
                    <form @submit.prevent="handlePartnerAddSubmit" class="form-horizontal" data-vv-scope="partnerAdd">
                        <div class="card-body">
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="farm_name">Search
                                    Partner</label>
                                <div class="col-sm-5">
                                    <multiselect
                                            :class="{'is-invalid': submittedPartnerAdd && errors.has('partnerAdd.partner')}"
                                            :clear-on-select="false"
                                            :close-on-select="true"
                                            :hide-selected="true"
                                            :internal-search="false"
                                            :limit="3"
                                            :loading="isLoading"
                                            :max-height="600"
                                            :options="partners"
                                            :options-limit="300"
                                            :searchable="true"
                                            :show-no-results="false"
                                            @search-change="searchPartners"
                                            class="form-control multiselect-sm"
                                            data-vv-as="partner"
                                            id="partner"
                                            label="partner"
                                            name="partner"
                                            open-direction="bottom"
                                            placeholder="Search Partners"
                                            track-by="id"
                                            v-model="partner"
                                            v-validate="'required'">
                                        <template slot="singleLabel" slot-scope="props">
                                            {{props.option.org_name}} - {{props.option.marketplace_name}}
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <div class="option__desc" v-if="props.option">
                                                    <h5>{{ props.option.org_name }} (<i>{{props.option.biz_email}}</i>)
                                                    </h5>
                                                    <h6>{{props.option.marketplace_name}}</h6>
                                                    <span>{{ props.option.line1}}</span>
                                                    <span>{{ props.option.city+', '+
                                                        props.option.country}}</span>
                                                </div>
                                                <div class="option__desc" v-else>
                                                    <h5>Add New</h5>
                                                </div>
                                            </div>
                                        </template>
                                    </multiselect>
                                    <div class="invalid-feedback"
                                         v-if="submittedPartnerAdd && errors.has('partnerAdd.partner')">{{
                                        errors.first('partnerAdd.partner') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="form-group m-b-0 text-right">
                                <div class="button-group">
                                    <button class="btn waves-effect waves-light btn-success" type="submit">Save</button>
                                    <button @click="resetPartnerAdd" class="btn waves-effect waves-light btn-secondary"
                                            type="reset">Reset
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <h4 class="text-center">OR</h4>

        <!--        CREATE A NEW PARTNER ORGANIZATION       -->
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Creat New Partner</h4>
                        <h6 class="card-subtitle">Invite a new partner.</h6>
                    </div>
                    <form @submit.prevent="handleSubmit" class="form-horizontal" data-vv-scope="newPartner">
<!--                        <div class="card-body card-blue">-->
<!--                            <div class="form-group row">-->
<!--                                <label class="col-sm-3 text-right control-label col-form-label" for="farm_name">Farm-->
<!--                                    Name</label>-->
<!--                                <div class="col-sm-5">-->
<!--                                    <input :class="{'is-invalid': submitted && errors.has('newPartner.farm_name')}"-->
<!--                                           class="form-control"-->
<!--                                           data-vv-as="Farm Name"-->
<!--                                           id="farm_name"-->
<!--                                           name="farm_name"-->
<!--                                           placeholder="Name"-->
<!--                                           type="text"-->
<!--                                           v-model="grower.name"-->
<!--                                           v-validate="'required'">-->
<!--                                    <small class="form-text text-muted">This is how others will identify your-->
<!--                                        farm</small>-->
<!--                                    <div class="invalid-feedback"-->
<!--                                         v-if="submitted && errors.has('newPartner.farm_name')">{{-->
<!--                                        errors.first('newPartner.farm_name') }}-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="form-group row">-->
<!--                                <label class="col-sm-3 text-right control-label col-form-label" for="description">Description</label>-->
<!--                                <div class="col-sm-5">-->
<!--                                    <textarea :class="{'is-invalid': submitted && errors.has('newPartner.description')}"-->
<!--                                              class="form-control"-->
<!--                                              data-vv-as="Description"-->
<!--                                              id="description"-->
<!--                                              name="description"-->
<!--                                              placeholder="Description"-->
<!--                                              rows=4-->
<!--                                              type="text"-->
<!--                                              v-model="grower.description">-->
<!--                                    </textarea>-->
<!--                                    <div class="invalid-feedback"-->
<!--                                         v-if="submitted && errors.has('newPartner.description')">{{-->
<!--                                        errors.first('newPartner.description') }}-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->

                        <div class="card-body card-blue">
                            <h6 class="card-title">Primary Contact</h6>

                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="first_name">Contact
                                    Name</label>
                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': submitted && errors.has('newPartner.first_name')}"
                                           class="form-control"
                                           data-vv-as="First Name"
                                           id="first_name"
                                           name="first_name"
                                           placeholder="First Name"
                                           type="text"
                                           v-model="grower.first_name"
                                           v-validate="'required'">
                                    <div class="invalid-feedback"
                                         v-if="submitted && errors.has('newPartner.first_name')">{{
                                        errors.first('newPartner.first_name') }}
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': submitted && errors.has('newPartner.last_name')}"
                                           class="form-control"
                                           data-vv-as="Last Name"
                                           id="last_name"
                                           name="last_name"
                                           placeholder="Last Name"
                                           type="text"
                                           v-model="grower.last_name"
                                           v-validate="'required'">
                                    <div class="invalid-feedback"
                                         v-if="submitted && errors.has('newPartner.last_name')">{{
                                        errors.first('newPartner.last_name') }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="email">Contact
                                    Email</label>
                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': submitted && errors.has('newPartner.email')}"
                                           class="form-control"
                                           data-vv-as="Email"
                                           id="email"
                                           name="email"
                                           placeholder="Email"
                                           type="text"
                                           v-model="grower.email"
                                           v-validate="'required|email'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('newPartner.email')">{{
                                        errors.first('newPartner.email') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body card-blue">
                            <h6 class="card-title">Business Info</h6>

                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="biz_name">Legal
                                    Name</label>
                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': submitted && errors.has('newPartner.biz_name')}"
                                           class="form-control"
                                           data-vv-as="Business Name"
                                           id="biz_name"
                                           name="biz_name"
                                           placeholder="Business Name"
                                           type="text"
                                           v-model="grower.biz_name"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('newPartner.biz_name')">
                                        {{
                                        errors.first('newPartner.biz_name') }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label"
                                       for="biz_phone">Phone</label>
                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': submitted && errors.has('newPartner.biz_phone')}"
                                           class="form-control"
                                           data-vv-as="Phone"
                                           id="biz_phone"
                                           name="biz_phone"
                                           placeholder="Phone"
                                           type="text"
                                           v-model="grower.biz_phone"
                                           v-validate="''">
                                    <div class="invalid-feedback"
                                         v-if="submitted && errors.has('newPartner.biz_phone')">{{
                                        errors.first('newPartner.biz_phone') }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label"
                                       for="biz_email">Email</label>
                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': submitted && errors.has('newPartner.biz_email')}"
                                           class="form-control"
                                           data-vv-as="Phone"
                                           id="biz_email"
                                           name="biz_email"
                                           placeholder="Email"
                                           type="text"
                                           v-model="grower.biz_email"
                                           v-validate="'required'">
                                    <div class="invalid-feedback"
                                         v-if="submitted && errors.has('newPartner.biz_email')">{{
                                        errors.first('newPartner.biz_email') }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label"
                                       for="biz_web">Web</label>
                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': submitted && errors.has('newPartner.biz_web')}"
                                           class="form-control"
                                           data-vv-as="Phone"
                                           id="biz_web"
                                           name="biz_phone"
                                           placeholder="Web"
                                           type="text"
                                           v-model="grower.biz_web"
                                           v-validate="''">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('newPartner.biz_web')">
                                        {{
                                        errors.first('newPartner.biz_web') }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label"
                                       for="line1">Address</label>
                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': submitted && errors.has('newPartner.line1')}"
                                           class="form-control"
                                           data-vv-as="Address Line 1"
                                           id="line1"
                                           name="line1"
                                           placeholder="Address Line 1"
                                           type="text"
                                           v-model="grower.line1"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('newPartner.line1')">{{
                                        errors.first('newPartner.line1') }}
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': submitted && errors.has('newPartner.line2')}"
                                           class="form-control"
                                           data-vv-as="Address Line 2"
                                           id="line2"
                                           name="line2"
                                           placeholder="Address Line 2"
                                           type="text"
                                           v-model="grower.line2">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('newPartner.line2')">{{
                                        errors.first('newPartner.line2') }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="city"></label>
                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': submitted && errors.has('newPartner.city')}"
                                           class="form-control"
                                           data-vv-as="City"
                                           id="city"
                                           name="city"
                                           placeholder="City"
                                           type="text"
                                           v-model="grower.city"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('newPartner.city')">{{
                                        errors.first('newPartner.city') }}
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': submitted && errors.has('newPartner.state')}"
                                           class="form-control"
                                           data-vv-as="State"
                                           id="state"
                                           name="state"
                                           placeholder="State or Province"
                                           type="text"
                                           v-model="grower.state"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('newPartner.state')">{{
                                        errors.first('newPartner.state') }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label"
                                       for="postal_code"></label>
                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': submitted && errors.has('newPartner.postal_code')}"
                                           class="form-control"
                                           data-vv-as="Postal Code"
                                           id="postal_code"
                                           name="postal_code"
                                           placeholder="Postal Code"
                                           type="text"
                                           v-model="grower.postal_code"
                                           v-validate="'required'">
                                    <div class="invalid-feedback"
                                         v-if="submitted && errors.has('newPartner.postal_code')">{{
                                        errors.first('newPartner.postal_code') }}
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <multiselect :class="{'is-invalid': submitted && errors.has('newPartner.country')}"
                                                 :options="countries"
                                                 class="form-control"
                                                 data-vv-as="Country"
                                                 id="country"
                                                 label="name"
                                                 name="country"
                                                 placeholder="Country"
                                                 track-by="code"
                                                 v-model="selectedCountry"
                                                 v-validate="'required'">
                                    </multiselect>

                                    <div class="invalid-feedback" v-if="submitted && errors.has('newPartner.country')">
                                        {{
                                        errors.first('newPartner.country') }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card-footer">
                            <div class="form-group m-b-0 text-right">
                                <div class="button-group">
                                    <button class="btn waves-effect waves-light btn-success" type="submit">Save</button>
                                    <button @click="reset()" class="btn waves-effect waves-light btn-secondary"
                                            type="button">Reset
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import {mapGetters} from "vuex";
    import countries from "../../../../assets/js/countries";

    export default {
        name: "AddGrower",
        components: {Multiselect},
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                submitted: false,
                submittedPartnerAdd: false,
                countries: countries,
                selectedCountry: {
                    code: '',
                    name: ''
                },
                grower: {
                    name: '',
                    description: '',
                    email: '',
                    biz_name: '',
                    biz_phone: '',
                    biz_web: '',
                    biz_email: '',
                    line1: '',
                    line2: '',
                    city: '',
                    state: '',
                    postal_code: '',
                    country: '',
                    country_code: ''
                },
                isLoading: false,
                partners: [],
                partner: null
            };
        },
        mounted() {
            jQuery('#begins').datepicker({
                autoclose: true,
                todayHighlight: true
            }).on('change', (event) => {
                this.grower.begin = event.target.value;
            });

        },
        methods: {
            async searchPartners(searchText) {
                try {
                    let {data} = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/partner/search`, {
                        params: {
                            search: searchText
                        }
                    });
                    this.partners = data;
                } catch (e) {

                }
            },
            save() {
                this.country = this.selectedCountry.name;
                this.country_code = this.selectedCountry.code;
                this.grower.name = this.grower.biz_name;

                this.$http.post("/marketplaces/" + this.currentOrg.marketplace_id + "/members", this.grower)
                    .then(reply => {
                        this.reset();
                        this.$swal({
                            type: 'success',
                            title: 'Approval Request Sent',
                            text: 'Sending the user details for approval to admin. Please wait for approval',
                            timer: 5000
                        });
                    })
                    .catch(err => {
                        console.log(err)
                    });
            },
            handleSubmit(e) {
                this.submitted = true;
                this.$validator.validateAll('newPartner')
                    .then(valid => {
                        if (valid) {
                            this.save();
                        }
                    });
            },
            handlePartnerAddSubmit(e) {
                this.submittedPartnerAdd = true;
                this.$validator.validateAll('partnerAdd')
                    .then(valid => {
                        if (valid) {
                            this.partnerAdd();
                        }
                    });
            },
            async partnerAdd() {
                try {
                    await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/partners/${this.partner.org_id}/add`);
                    this.resetPartnerAdd();
                    await this.$swal({
                        type: 'success',
                        title: 'Approval Request Sent',
                        text: 'Request has been with the user details for approval. Please wait for response',
                        timer: 5000
                    });
                } catch (e) {
                    console.error(e)
                }
            },
            reset() {
                this.submitted = false;
                this.grower = {
                    name: '',
                    description: '',
                    email: '',
                    biz_name: '',
                    biz_phone: '',
                    biz_web: '',
                    biz_email: '',
                    line1: '',
                    line2: '',
                    city: '',
                    state: '',
                    postal_code: '',
                    country: '',
                    country_code: ''
                }
            },
            resetPartnerAdd() {
                this.submittedPartnerAdd = false;
                this.partner = null;
            }
        }
    }
</script>

<style scoped>

</style>
